import React from 'react';

const MatrixAnalysisMenu = props => {
    const {
        toggleDisplayAsIcons,
        displayAsIcons,
        toggleShowSinglePercentage,
        toggleShowPanels,
        updateTableByPlatform,
        displayTableByPlatform,
        showPanels,
        toggleReadTriggersDataFromLogs,
        readTriggersDataFromLogs,
    } = props;

    return (
        <div className="matrix-analytics-menu">
            <div style={{ display: 'block' }}>
                <div className="display-as-icons-container">
                    <input
                        id={'toggle-display-as-icons'}
                        className="cmn-toggle cmn-toggle-round"
                        type="checkbox"
                        onChange={toggleDisplayAsIcons}
                        checked={displayAsIcons}
                    />
                    <label htmlFor={'toggle-display-as-icons'} />
                    <span className="display-as-icons-text">Display as icons</span>
                </div>

                <div className="display-as-icons-container" onChange={toggleReadTriggersDataFromLogs}>
                    <p>Read data from:</p>
                    <div>
                        <input
                            type="radio"
                            id="from-logs"
                            name="Logs"
                            value="true"
                            checked={readTriggersDataFromLogs}
                        />
                        <label>Logs</label>
                    </div>
                    <div>
                        <input type="radio" id="from-db" name="db" value="true" checked={!readTriggersDataFromLogs} />
                        <label>Database</label>
                    </div>
                </div>
            </div>

            <div className="show-single-percentage-container" onChange={e => toggleShowSinglePercentage(e)}>
                <input
                    type="radio"
                    name="toggle-show-single-percentage"
                    id="toggle-show-single-percentage-false"
                    value="false"
                    defaultChecked
                />
                <label htmlFor="toggle-show-single-percentage-false">Show Hit %</label>
                <br />
                Single triggers and over-triggers
                <br />
                <input
                    type="radio"
                    name="toggle-show-single-percentage"
                    id="toggle-show-single-percentage-true"
                    value="true"
                />
                <label htmlFor="toggle-show-single-percentage-true">Show Single %</label>
                <br />
                Single triggers only
            </div>

            <div className="icons-legend-container">
                <div className="green large-text">
                    {displayAsIcons ? (
                        <span className="glyphicon glyphicon-ok-sign" />
                    ) : (
                        <span className="bold">1</span>
                    )}
                    <span>Single: Device triggered zone once</span>
                </div>
                <div className="orange large-text">
                    {displayAsIcons ? (
                        <span className="glyphicon glyphicon-exclamation-sign" />
                    ) : (
                        <span className="bold">2</span>
                    )}
                    Over-trigger: Device triggered zone more than once
                </div>
                <div className="red large-text">
                    {displayAsIcons ? (
                        <span className="glyphicon glyphicon-remove-sign" />
                    ) : (
                        <span className="bold">0</span>
                    )}
                    Miss: Device did not trigger zone
                </div>
            </div>

            <button type="button" className="btn btn-default" onClick={toggleShowPanels}>
                {showPanels ? `Hide` : `Show`} panels
            </button>

            <label>By OS:</label>
            <select id="displayTableByPlatform" onChange={updateTableByPlatform} value={displayTableByPlatform}>
                <option value="Both">Both</option>
                <option value="Android">Android</option>
                <option value="iOS">iOS</option>
            </select>
        </div>
    );
};

export default MatrixAnalysisMenu;
